<template>
    <div>
        <div class="w-100"
            style="background-image: url('/files/img/portfolio/mstudio/main01_o.jpg'); background-position: 50% 50%; background-size: cover;">
            <div class="x_div_center" style="height:100%; background-color:rgba(0, 0, 0, 0.3);">
                <div class="rp_set px-3" style="padding:120px 0 0 0;">
                    <span class="dh_p1b">M Studio</span><br>
                    <span class="dh_p1c">M3Systems 의 DfMA 모듈러 건축기술을 적용하여, <br>정제된 모던함과 견고한 품질을 갖춘 M Studio를
                        소개합니다.</span>
                    <div style="height: 60px;"></div>
                </div>
            </div>
        </div>

        <div class="x_div_center">
            <div class="rp_set" style="border:0px solid red">
                <!-- header info -->
                <div class="py-3">
                    <div class="iw-1">
                        <div class="iw-5 px-1 py-2" style="justify-content:left !important">
                            <div class="py-2" style="width: 95%">
                                <div class="px-3 fkr-set1 fs-10"
                                    style="padding-left:0 !important; border-bottom: 1px solid #333">건축 용도</div>
                                <div class="px-3 fkr-set2 fs-09" style="padding-left:0 !important;">체류형 쉼터</div>
                            </div>
                        </div>
                        <div class="iw-5 px-1 py-2" style="justify-content:left !important">
                            <div class="py-2" style="width: 95%">
                                <div class="px-3 fkr-set1 fs-10"
                                    style="padding-left:0 !important; border-bottom: 1px solid #333">주요 구조</div>
                                <div class="px-3 fkr-set2 fs-09" style="padding-left:0 !important;">철골조</div>
                            </div>
                        </div>
                        <div class="iw-5 px-1 py-2" style="justify-content:left !important">
                            <div class="py-2" style="width: 95%">
                                <div class="px-3 fkr-set1 fs-10"
                                    style="padding-left:0 !important; border-bottom: 1px solid #333">공사 기간</div>
                                <div class="px-3 fkr-set2 fs-09" style="padding-left:0 !important;">제조 5주 / 설치 1일</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="height:30px"></div>

                <div class="py-3">
                    <!-- carousel image -->
                    <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
                        <div class="carousel-indicators">
                            <button v-for="(v, i) in carouselImg" :key="i" type="button"
                                data-bs-target="#carouselExampleCaptions" :data-bs-slide-to="i"
                                :class="i == 0 ? 'active' : ''" :aria-current="i == 0 ? 'true' : ''"
                                :aria-label="'Slide ' + (i + 1)"></button>
                        </div>
                        <div class="carousel-inner">
                            <div v-for="(v, i) in carouselImg" :key="i"
                                :class="'carousel-item' + (i == 0 ? ' active' : '')">
                                <div class="iw-1">
                                    <img :src="'/files/img/portfolio/mstudio/' + v" :style="setStyleCarousel(v)">
                                </div>
                            </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions"
                            data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions"
                            data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                        </button>
                    </div>

                    <!-- main images(4 slots) -->
                    <div class="iw-1 py-2 w-100">
                        <div class="iw-3 d-flex" style="align-items:start;">
                            <div class="iw-3" style="align-items:start;">
                                <div
                                    :style="'width:100%; position: relative; overflow: hidden; height: ' + (viewWidth >= 1024 ? pageWidth / 4 : pageWidth / 2) + 'px;'">
                                    <img :src="'/files/img/portfolio/' + (this.mainImg[0] ? 'mstudio/' + this.mainImg[0] : 'whitebg.png')"
                                        :style="setStyleMains(this.mainImg[0])" width="100%">
                                </div>
                            </div>
                            <div class="p-2"></div>
                            <div class="iw-3" style="align-items:start;">
                                <div
                                    :style="'width:100%; position: relative; overflow: hidden; height: ' + (viewWidth >= 1024 ? pageWidth / 4 : pageWidth / 2) + 'px;'">
                                    <img :src="'/files/img/portfolio/' + (this.mainImg[1] ? 'mstudio/' + this.mainImg[1] : 'whitebg.png')"
                                        :style="setStyleMains(this.mainImg[1])" width="100%">
                                </div>
                            </div>
                        </div>
                        <div class="p-2"></div>
                        <div class="iw-3 d-flex" style="align-items:start;">
                            <div class="iw-3" style="align-items:start;">
                                <div
                                    :style="'width:100%; position: relative; overflow: hidden; height: ' + (viewWidth >= 1024 ? pageWidth / 4 : pageWidth / 2) + 'px;'">
                                    <img :src="'/files/img/portfolio/' + (this.mainImg[2] ? 'mstudio/' + this.mainImg[2] : 'whitebg.png')"
                                        :style="setStyleMains(this.mainImg[2])" width="100%">
                                </div>
                            </div>
                            <div class="p-2"></div>
                            <div class="iw-3" style="align-items:start;">
                                <div
                                    :style="'width:100%; position: relative; overflow: hidden; height: ' + (viewWidth >= 1024 ? pageWidth / 4 : pageWidth / 2) + 'px;'">
                                    <img :src="'/files/img/portfolio/' + (this.mainImg[3] ? 'mstudio/' + this.mainImg[3] : 'whitebg.png')"
                                        :style="setStyleMains(this.mainImg[3]) + (carouselImg.length > 4 ? 'filter:brightness(50%);' : '')"
                                        width="100%">
                                    <span style="position:absolute; top:40%; left:40%; color:#fff">
                                        <h1>{{ carouselImg.length > 4 ? ('+' + (carouselImg.length - 4)) : '' }}</h1>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- description -->
                <div style="height:50px"></div>
                <div class="py-3">
                    <p class="fkr-set2 fs-13"><strong>이동식 건축의 새로운 기준</strong></p>
                    <p class="fkr-set2 fs-09">M Studio는 더 나은 생활과 경험을 위해 설계되었습니다. <br>고객님의 삶 속에 단단한 바탕이 되기 위해 공간의 크기를 넘어,
                        최적의 공간구성과 적재적소 디테일까지 고민했습니다.</p>
                </div>

                <div style="height:50px"></div>

                <!-- card images(single left + 2 layered right) -->
                <div class="py-3">
                    <div class="iw-1 py-2 w-100">
                        <div class="iw-3 d-flex" style="align-items:start;">
                            <div
                                :style="'width:100%; position: relative; overflow: hidden; height: ' + (viewWidth >= 1024 ? pageWidth / 2 : pageWidth) + 'px;'">
                                <img :src="'/files/img/portfolio/mstudio/main06_h.jpg'"
                                    :style="setStyleMains('main06_h.jpg')" width="100%">
                            </div>
                        </div>
                        <div class="p-2"></div>
                        <div class="iw-3" style="align-items:start;">
                            <!-- horizontal images only!! -->
                            <div
                                :style="'width:100%; position: relative; overflow: hidden; height: ' + (viewWidth >= 1024 ? pageWidth / 4 - 8 : pageWidth / 2 - 8) + 'px;'">
                                <img :src="'/files/img/portfolio/mstudio/main07_h.jpg'"
                                    style="position: absolute; top: -25%; left: 0; width: 100%; height: auto;"
                                    width="100%">
                            </div>
                            <div style="height:16px"></div>
                            <div
                                :style="'width:100%; position: relative; overflow: hidden; height: ' + (viewWidth >= 1024 ? pageWidth / 4 - 8 : pageWidth / 2 - 8) + 'px;'">
                                <img :src="'/files/img/portfolio/mstudio/main08_h.jpg'"
                                    style="position: absolute; top: -25%; left: 0; width: 100%; height: auto;"
                                    width="100%">
                            </div>
                        </div>
                    </div>
                </div>


                <!-- description -->
                <!-- <div style="height:50px"></div>
                <div class="py-3">
                    <p class="fkr-set2 fs-13"><strong>실내공간 디테일</strong></p>
                    <p class="fkr-set2 fs-09">수납은 주거공간에서 중요한 부분입니다.<br>동선의 효율성, 합리적인 공간 활용, 정돈된 공간과 차분한 느낌은<br>구석구석 낭비
                        없는 M Studio의 수납 시스템으로 완성됩니다.</p>
                </div> -->
                <div style="height:50px"></div>
                <div class="py-3">
                    <p class="fkr-set2 fs-13"><strong>혁신적이고 독보적인 디자인</strong></p>
                    <p class="fkr-set2 fs-09">좁고 기다란 디자인에서 탈피한 넓은 공간감.<br>그러면서도 운송과 설치가 간편해야 함은 기본입니다.<br>
                        M3시스템즈만의 특허받은 수납형 디자인으로 완성하였습니다.</p>
                </div>


                <div style="height:50px"></div>

                <!-- card images(horizontal single left + vertical single right) -->
                <div class="py-3">
                    <div class="iw-1 py-2 w-100">
                        <div class="iw-1 d-flex" style="align-items:start;">
                            <!-- horizontal image only!! -->
                            <img :src="'/files/img/portfolio/mstudio/main09_v.jpg'" width="100%">
                        </div>
                        <div class="p-2"></div>
                        <!-- <div class="iw-2 d-flex" style="align-items:start;"> -->
                        <div class="iw-1 d-flex" style="align-items:start;">
                            <div>
                                <!-- <div
                                :style="'width:100%; position: relative; overflow: hidden; height: ' + (isMobile ? pageWidth * 1.33 : pageWidth / 3 * 1.43) + 'px'"> -->
                                <!-- <img :src="'/files/img/portfolio/mstudio/main10_h.jpg'"
                                    :style="setStyleVertical('main10_h.jpg')" width="100%"> -->
                                <img :src="'/files/img/portfolio/mstudio/main10_h.jpg'" width="100%">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- description -->
                <div style="height:50px"></div>
                <div class="py-3">
                    <p class="fkr-set2 fs-13"><strong>미니멀 디자인</strong></p>
                    <p class="fkr-set2 fs-09">M Studio는 복잡함과 이유없는 장식은 덜어내고, 선과 면의 간결함으로 세련된 공간을 제공합니다.<br>단정한 형태로 유지관리가
                        용이하며, 다양한 장소와 조화를 이룹니다.</p>
                </div>
                <div style="height:50px"></div>

                <!-- specifiaction -->
                <div class="table-responsive" style="border-top:3px solid #c9c9c9; border-bottom:3px solid #c9c9c9">
                    <table class="table-borderless w-100">
                        <tr style="height:55px;">
                            <td :width="isMobile ? '50%' : '20%'"><span
                                    class="fkr-set1">용&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;도&nbsp;&nbsp;&nbsp;Usage</span>
                            </td>
                            <td :width="isMobile ? '50%' : '80%'"><span class="fkr-set2">체류형 쉼터</span></td>
                        </tr>
                        <tr style="height:55px;">
                            <td :width="isMobile ? '50%' : '20%'"><span
                                    class="fkr-set1">구&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;조&nbsp;&nbsp;&nbsp;Structure</span>
                            </td>
                            <td :width="isMobile ? '50%' : '80%'"><span class="fkr-set2">철골조</span></td>
                        </tr>
                        <tr style="height:55px;">
                            <td :width="isMobile ? '50%' : '20%'"><span class="fkr-set1">건축면적&nbsp;&nbsp;&nbsp;Building
                                    area</span></td>
                            <td :width="isMobile ? '50%' : '80%'"><span class="fkr-set2">32.1 ㎡</span></td>
                            <!--(6평) -->
                        </tr>
                        <tr style="height:55px;">
                            <td :width="isMobile ? '50%' : '20%'"><span class="fkr-set1">연 면 적&nbsp;&nbsp;&nbsp;Total
                                    floor area</span></td>
                            <td :width="isMobile ? '50%' : '80%'"><span class="fkr-set2">32.1 ㎡</span></td>
                        </tr>
                        <tr style="height:55px;">
                            <td :width="isMobile ? '50%' : '20%'"><span
                                    class="fkr-set1">층&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;수&nbsp;&nbsp;&nbsp;Floors</span>
                            </td>
                            <td :width="isMobile ? '50%' : '80%'"><span class="fkr-set2">1층</span></td>
                        </tr>
                    </table>
                </div>
                <!-- 내용 수정으로 인한 변경 - DeclanKim 2025.12.03.sprint2 -->
                <!-- <div class="x_div_end py-2"><button @click="openModalForSimulation()" class="fkr-set2 fs-095"
                        style="width:120px; height:37px; border:0; background-color:#4e0000; color:#fff; border-radius:4px">시뮬레이션
                        보기</button></div> -->

                <div style="height:50px"></div>

                <PortfolioNavigation :isMobile="isMobile" />
                <!-- <MenuFooter /> -->
            </div>

            <div id="v-view" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true" style="z-index:10001;">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">

                        <div class="w-100">
                            <div class="x_div_center w-100"
                                style="background-color:#dccccc; border-top-left-radius:8px; border-top-right-radius:8px">
                                <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-13"> 시뮬레이션 </span></div>
                                <div class="text-end pe-4" style="width:100px"><a href="#@" @click="closeModal()"
                                        style="color:#4e0000" data-dismiss="modal"><i
                                            class="fa-solid fa-xmark fs-15"></i></a></div>
                            </div>

                            <div class="x_div_center py-2 px-4">
                                <div class="w-100 x_div_center py-3">
                                    <iframe id="ifr" ref="ifrm" src=""></iframe>
                                </div>
                            </div>

                            <div class="x_div_center py-4">
                                <div class="px-2"><button @click="closeModal()" class="x_div_center"
                                        style="width:90px; height:30px; border:0; background-color:#fff; border:1px solid #4e0000; border-radius:4px; color:#4e0000"
                                        data-dismiss="modal"><span class="fkr-set1">닫기</span></button></div>
                            </div>

                            <div style="height:20px"></div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MenuFooter from '@/components/MenuFooter.vue'
import PortfolioNavigation from '@/components/PortfolioNavigation.vue'

var gIfrmMobuilder = null;

export default {
    name: 'PortfolioMStudio',
    components: {
        MenuFooter, PortfolioNavigation
    },
    data() {
        return {
            isMobile: false,
            pageWidth: 0,
            viewWidth: 0,
            carouselImg: ['main01_o.jpg', 'main02_h.jpg', 'main03_h.jpg', 'main04_h.jpg'],
            mainImg: []
        }
    },
    created() {
        for (var i = 0; (i < this.carouselImg.length && i < 4); i++) {
            this.mainImg[i] = this.carouselImg[i];
        }
        for (; i < 4; i++) {
            this.mainImg[i] = '';
        }
    },
    mounted() {
        // eslint-disable-next-line
        var swiper = new window.Swiper('.swiper-container', {
            slidesPerView: 1,
            spaceBetween: 20,
            effect: 'fade',
            loop: true,
            speed: 300,
            mousewheel: {
                invert: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });

        this.isMobile = window.innerWidth < 768;
        this.viewWidth = window.innerWidth;
        this.pageWidth = Number(window.$('.rp_set.px-3').css('width').split('px')[0]);

        // this.$refs.ifrm.src = "https://mobuild.cafe24.com/mobuilder/index/public/?ma=builder&mu=modeUserMain";

        // const gIframe = document.getElementById("ifr");

        // gIframe.addEventListener("load", function () {
        //     gIfrmMobuilder = (gIframe.contentWindow) ? gIframe.contentWindow :
        //         (gIframe.contentDocument.document) ? gIframe.contentDocument.document : gIframe.contentDocument;
        // });

        // window.addEventListener('message', (e) => {
        //     // console.log('================== post message ====================')
        //     // console.log(e.data);
        //     if (e.data.functionName == 'fExpandMobuilderFrame') {
        //         this.expandIframe(e.data.para[0]);
        //     }
        //     else if (e.data.functionName == 'fMobuilderCallback') {

        //         const gjMenuSet = {
        //             "project": {            // 프로젝트
        //                 "outline": true,    // - 사업 개요
        //                 "info": true,       // - 사업 정보
        //             },
        //             "land": {               // 대지
        //                 "address": true,    // - 주소 입력
        //                 "danji": false,     // - 단지 선택 <-- 숨기기
        //                 "info": true        // - 대지 정보
        //             },
        //             "model": {              // 모델
        //                 "outline": true,    // - 모델 개요
        //                 "info": true,       // - 모델 정보
        //                 "build": true       // - 모델 수정
        //             }
        //         }

        //         gIfrmMobuilder.postMessage({
        //             functionName: "fSidebarSetMenu",
        //             para: [JSON.stringify(gjMenuSet)]
        //         }, "*");

        //         gIfrmMobuilder.postMessage({
        //             functionName: "fSidebarDisplayMenu",   // 실행할 함수명
        //             para: ["hideTopMenu"]                  // 함수에 전달할 인수 배열
        //         }, "*");
        //     }
        // });
    },
    methods: {
        setStyleCarousel(img) {
            if (this.isMobile) {
                return 'width:100%';
            }
            else {
                var side = img.split('_')[1];
                if (side.indexOf('v') >= 0) {
                    return 'height:' + this.pageWidth / 1.33 + 'px'
                }
                else {
                    return 'width:100%'
                }
            }
        },
        setStyleMains(img) {
            if (img) {
                var side = img.split('_')[1];
                if (side.indexOf('v') >= 0) {
                    return 'position: absolute; top: -25%; left: 0; width: 100%; height: auto;'
                }
                else if (side.indexOf('o') >= 0) {
                    return 'position: absolute; top: 0; left: 0%; width: 100%; height: 100%;'
                }
                else {
                    //return 'position: absolute; top: 0; left: -75%; width: auto; height: ' + (this.pageWidth >= 1024 ? this.pageWidth/2 : this.pageWidth) + 'px;'
                    return 'position: absolute; top: 0; left: -25%; width: auto; height: 100%'
                }
            }
            else {
                return 'position: absolute; top: -25%; left: 0; width: 100%; height: auto;'
            }
        },
        setStyleVertical(img) {
            var side = img.split('_')[1];
            if (side.indexOf('v') >= 0) {
                return 'position: absolute; width: 103%; height: auto;'
            }
            else {
                return 'position: absolute; width:auto; ' + (this.isMobile ? 'height:' + this.pageWidth * 1.33 : 'top: 0; left: -25%; height:' + (this.pageWidth / 3) * 1.43) + 'px;'
            }
        },
        expandIframe(mode) {
            if (mode == 'expand') {
                window.$('#ifr').css('z-index', 10002);
                window.$('#ifr').css('position', 'fixed');
                window.$('#ifr').css('top', '0');
                window.$('#ifr').css('height', '100%');
            }
            else if (mode == 'return') {
                window.$('#ifr').css('z-index', 1);
                window.$('#ifr').css('position', 'relative');
                window.$('#ifr').css('top', 'auto');
                window.$('#ifr').css('height', this.isMobile ? '600px' : '1000px');
            }
        },
        openModalForSimulation() {
            gIfrmMobuilder.postMessage({
                functionName: "fLoadIfcByParent",
                para: ["11-PRS", "PRS-01-00-00", "PRS-01-00-00", '']       // PRS-04-00-00로 모빌더 동기화 필요!!
            }, "*");

            gIfrmMobuilder.postMessage({
                functionName: "fSelectSidebarMenu",
                para: ["model", "", ""]
            }, "*");

            gIfrmMobuilder.postMessage({
                functionName: "fSidebarClose",
                para: []
            }, "*");

            this.openModal()
        },
        openModal() {
            window.$('#v-view').modal('show');
        },
        closeModal() {
            window.$('#v-view').modal('hide');
        }
    }
}
</script>

<style scoped>
@media (max-width:1023.98px) {
    #ifr {
        width: 100%;
        height: 600px;
    }
}

@media (min-width:1024px) {
    #ifr {
        width: 100%;
        height: 1000px;
    }
}
</style>